export const INSURELY_IFRAME_MAX_WIDTH = 700
export const INSURELY_IFRAME_MAX_HEIGHT = 790
